/**
 * @flow
 * @relayHash c0131e43d3ac95bb73b89a1207dd1b29
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type dealsFiltersLocationsQueryVariables = {||};
export type dealsFiltersLocationsQueryResponse = {|
  +cities: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
  |}>
|};
export type dealsFiltersLocationsQuery = {|
  variables: dealsFiltersLocationsQueryVariables,
  response: dealsFiltersLocationsQueryResponse,
|};
*/


/*
query dealsFiltersLocationsQuery {
  cities(filter: DEALS) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "cities",
    "storageKey": "cities(filter:\"DEALS\")",
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": "DEALS"
      }
    ],
    "concreteType": "City",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "dealsFiltersLocationsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "dealsFiltersLocationsQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "dealsFiltersLocationsQuery",
    "id": null,
    "text": "query dealsFiltersLocationsQuery {\n  cities(filter: DEALS) {\n    id\n    name\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '08fc127788a634d726f7148a89d9a513';
module.exports = node;
